export const SET_PAGE_PERPAGE = 'SET_PAGE_PERPAGE';

export const setPagePerpage = (pageName, page, perpage) => dispatch => {
    dispatch({
        type: SET_PAGE_PERPAGE,
        pageName,
        page,
        perpage
    });
}